import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    ApiModel,
    BulkUploadDraftSellerModel,
    BulkUploadDraftSellerModelConverter,
    MaterialType,
    Product,
    Shape,
} from '@steelbuy/ts-shared';
import axios from '../../axios';

export const DRAFT_BULK_UPLOAD_KEY = 'draft-bulk-upload';

type CreateDraftBulkUploadRequest = {
    file: File;
    materialType: MaterialType;
    shape: Shape;
    product: Product;
    prime: boolean;
};

const createDraftBulkUpload = async (request: CreateDraftBulkUploadRequest): Promise<BulkUploadDraftSellerModel> => {
    const formData = new FormData();
    Object.entries(request).forEach(([field, value]) =>
        formData.append(field, typeof value === 'boolean' ? `${value}` : value)
    );
    const { data } = await axios.post<BulkUploadDraftSellerModel>(
        `/api/universal/bulk-listing-drafts/upload`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );
    const modelConverter = new BulkUploadDraftSellerModelConverter();
    const convertedData = modelConverter.toViewModel(data as unknown as ApiModel<BulkUploadDraftSellerModel>);
    return convertedData;
};

export const useCreateBulkUpload = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (request: CreateDraftBulkUploadRequest) => createDraftBulkUpload(request),
        onSuccess: (data: BulkUploadDraftSellerModel) => {
            queryClient.setQueryData([DRAFT_BULK_UPLOAD_KEY, data.bulkId], data);
        },
    });
};
